// extracted by mini-css-extract-plugin
export default {"container":"homePage_container__KIt-d","loading":"homePage_loading__ed-Le"};